import GenerateApiKeyRequestModelBase from '../_generated/modelBases/generate-api-key-request-model-base';

export default class GenerateApiKeyRequestModel extends GenerateApiKeyRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
